// Host-declared cancellation policy — shared by the host listing form and the
// driver-facing spot detail page. Wording is deliberately accurate about what
// MyRedPark ACTUALLY enforces today: cancellation is free before payment
// authorization/capture (the Stripe hold is voided, never charged); after
// capture, changes go through support review. The host's policy is a stated
// preference — it does NOT change refund enforcement and must never be
// presented as an automatic refund guarantee.
export const CANCELLATION_POLICIES = [
  {
    value: "flexible",
    label: "Flexible",
    hostHint: "You're relaxed about schedule changes — drivers can cancel any time before arrival.",
    driverText: "The host is flexible about cancellations.",
  },
  {
    value: "moderate",
    label: "Moderate",
    hostHint: "You appreciate reasonable notice when a driver needs to cancel.",
    driverText: "The host asks for reasonable notice when cancelling.",
  },
  {
    value: "strict",
    label: "Strict",
    hostHint: "You rely on bookings being kept — best for high-demand spaces.",
    driverText: "The host asks drivers to avoid late cancellations.",
  },
];

export const policyLabel = (value) =>
  CANCELLATION_POLICIES.find((p) => p.value === value)?.label || null;

export const CANCELLATION_PLATFORM_NOTE =
  "How cancellation works on MyRedPark: cancelling is free before your payment is authorized. After authorization, cancelling before your booking start refunds a percentage of the base fare based on notice — 75% at 72+ hours, 55% at 24–48 hours, and 0% under 24 hours. For cancellations 48–72 hours before the start, the refund percentage is under policy review and settled manually by our team. Service fees and payment processing fees are non-refundable. A no-show (arrival code not verified within 15 minutes of the start time) is charged in full and settled to the host. The host's policy is a stated preference and does not change refund enforcement.";
